module.exports = __webpack_public_path__ + "static/media/01.163f2947.jpg";